import { css } from '@emotion/react'
import { Button, ButtonProps } from 'bold-ui'

/**
 * @deprecated Utilize `ModalFooterButton` do `bold-ui`
 */
export const FooterButton = (props: ButtonProps) => {
  return (
    <Button
      {...props}
      style={css`
        min-width: 9rem;
        padding-left: 2rem;
        padding-right: 2rem;
      `}
    />
  )
}
